/**
 * Разбор значений, которые приходят как `unknown` (состояние перехода роутера, ошибка запроса), без приведения типов:
 * каждое поле проверяется там, где читается.
 */

/** Откуда пришли в окно: `windowBack` — возврат назад, `windowFrom` — адрес, с которого перешли. Нет состояния или поля — `false` и `null`. */
export function navigationOrigin(state: unknown): { back: boolean; from: string | null } {
  if (typeof state !== 'object' || state === null) return { back: false, from: null }
  const back = 'windowBack' in state && state.windowBack === true
  const from = 'windowFrom' in state && typeof state.windowFrom === 'string' ? state.windowFrom : null
  return { back, from }
}

/** Код ошибки службы (`error.code`); у ошибки без строкового кода — `undefined`. */
export function errorCodeOf(error: unknown): string | undefined {
  if (typeof error !== 'object' || error === null || !('code' in error)) return undefined
  return typeof error.code === 'string' ? error.code : undefined
}
